import React, { useState } from 'react';
import { leadsService } from '../services/api';

interface QuickActionsProps {
  onRefresh: () => void;
}

const QuickActions: React.FC<QuickActionsProps> = ({ onRefresh }) => {
  const [loading, setLoading] = useState(false);

  const handleBulkStatusUpdate = async (status: string) => {
    if (!window.confirm(`Tem certeza que deseja atualizar leads selecionados para "${status}"?`)) {
      return;
    }
    
    setLoading(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      alert('Status atualizado com sucesso!');
      onRefresh();
    } catch (error) {
      alert('Erro ao atualizar status');
    } finally {
      setLoading(false);
    }
  };

  const handleExportData = () => {
    // Simular download de CSV
    const csvContent = 'Numero Processo,Autor,Reu,Status\nExemplo1,João,Maria,Novo\n';
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'leads.csv';
    link.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow-sm border-l-4 border-blue-500 mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <span className="text-blue-600">⚡</span>
          <h3 className="text-sm font-medium text-gray-900">Ações Rápidas</h3>
        </div>
        <div className="flex space-x-2">
          <button
            onClick={() => handleBulkStatusUpdate('interessado')}
            disabled={loading}
            className="px-3 py-1 text-xs bg-yellow-100 text-yellow-800 rounded-md hover:bg-yellow-200 disabled:opacity-50"
            title="Marcar leads selecionados como interessados"
          >
            📋 Interessado
          </button>
          <button
            onClick={() => handleBulkStatusUpdate('em_negociacao')}
            disabled={loading}
            className="px-3 py-1 text-xs bg-orange-100 text-orange-800 rounded-md hover:bg-orange-200 disabled:opacity-50"
            title="Marcar leads selecionados como em negociação"
          >
            💬 Negociação
          </button>
          <button
            onClick={() => handleBulkStatusUpdate('fechado_ganho')}
            disabled={loading}
            className="px-3 py-1 text-xs bg-green-100 text-green-800 rounded-md hover:bg-green-200 disabled:opacity-50"
            title="Marcar leads selecionados como fechado ganho"
          >
            ✅ Ganho
          </button>
          <button
            onClick={handleExportData}
            className="px-3 py-1 text-xs bg-blue-100 text-blue-800 rounded-md hover:bg-blue-200"
            title="Exportar dados para CSV"
          >
            📊 Exportar
          </button>
          <button
            onClick={onRefresh}
            disabled={loading}
            className="px-3 py-1 text-xs bg-gray-100 text-gray-800 rounded-md hover:bg-gray-200 disabled:opacity-50"
            title="Atualizar dados"
          >
            🔄 Atualizar
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuickActions;